import { Stack, styled } from '@mui/material';

import { theme } from '@/shared/design-system';

export const ActivityList = styled(Stack)({
  flexDirection: 'column',
});

export const ActivityEntry = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'auto 1fr auto',
  alignItems: 'start',
  gap: theme.spacing[12],
  padding: `${theme.spacing[12]}px 0`,

  '& + &': {
    borderTop: `1px solid ${theme.colors.border.subtle}`,
  },
});

export const ActivityText = styled(Stack)({
  flexDirection: 'column',
  gap: theme.spacing[2],
  minWidth: 0,
});
